import PropTypes from 'prop-types';
import React from 'react';
import Badge from './badge';

// Status badge component
const StatusBadge = _ref => {
  let status = _ref.status;
  const config = {
    passed: {
      color: 'success',
      icon: '✓',
      label: 'Passed'
    },
    failed: {
      color: 'danger',
      icon: '✕',
      label: 'Failed'
    },
    warning: {
      color: 'warning',
      icon: '⚠',
      label: 'Warning'
    },
    unknown: {
      color: 'secondary',
      icon: '?',
      label: 'Unknown'
    }
  };
  const _ref2 = config[status] || config.unknown,
    color = _ref2.color,
    icon = _ref2.icon,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: color,
    pill: true,
    className: "quality-agent__status-badge"
  }, icon, " ", label);
};
StatusBadge.propTypes = {
  status: PropTypes.string.isRequired
};
export default StatusBadge;